import { render, staticRenderFns } from "./ReportingCardStats.vue?vue&type=template&id=2cb9a5a0&scoped=true"
import script from "./ReportingCardStats.vue?vue&type=script&lang=js"
export * from "./ReportingCardStats.vue?vue&type=script&lang=js"
import style0 from "./ReportingCardStats.vue?vue&type=style&index=0&id=2cb9a5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9a5a0",
  null
  
)

export default component.exports